/* eslint-disable react-hooks/exhaustive-deps */
import { useAxios } from '@/hooks';
import { setLoginPopup } from '@/redux/actions/common.action';
import { setCartData } from '@/redux/actions/user.action';
import { AppDispatch, RootState } from '@/redux/store';
import { endPoint, getCookie } from '@/utils';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface TProps {
  eventInfo: any;
  cartData: any;
}

const useTickets = ({ eventInfo, cartData }: TProps) => {
  const { loading, fetchData } = useAxios(Boolean(eventInfo?._id));
  const [tickets, setTickets] = useState([]);

  const searchParams = useSearchParams();
  const code = searchParams.get('code');
  const router = useRouter();
  const dispatch = useDispatch<AppDispatch>();
  const [dispatchCheckout, setDispatchCheckout] = useState(false);
  const isLoginPopupOpen = useSelector(
    (state: RootState) => state.common.isLoginPopupOpen,
  );
  const user = useSelector((state: RootState) => state.user.user);

  const fetchTickets = async () => {
    try {
      if (eventInfo?._id) {
        const res: any = await fetchData({
          url: endPoint.FETCH_EVENT_TICKETS,
          method: 'GET',
          params: eventInfo?.isRecurringEvent
            ? {
                eventId: eventInfo?._id,
                date: cartData?.selectedDate?.date,
                timeCode: cartData?.selectedTime?.code,
              }
            : {
                eventId: eventInfo?._id,
              },
        });
        setTickets(
          res?.data?.length > 0
            ? res?.data || []
            : eventInfo?.ticketTypes || [],
        );
      } else {
        setTickets(eventInfo?.ticketTypes);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleTicket = (ticket: any, value: number, opcode = '') => {
    const updatedTickets = { ...(cartData?.selectedTickets || {}) };

    if (opcode === 'remove') {
      delete updatedTickets[ticket.code];
    } else {
      updatedTickets[ticket.code] = {
        ...ticket,
        selected_ticket: value,
      };
    }

    dispatch(
      setCartData(
        cartData?.selectedDate,
        cartData?.selectedTime,
        updatedTickets,
      ),
    );
  };

  const goToCheckout = () => {
    dispatch(
      setCartData(
        cartData?.selectedDate,
        cartData?.selectedTime,
        cartData?.selectedTickets,
      ),
    );

    const checkoutURL = code
      ? `/${eventInfo?.eventCode}/checkout?code=${code}`
      : `/${eventInfo?.eventCode}/checkout`;
    router.push(checkoutURL);
  };

  const handleAddToCart = () => {
    const isLoggedIn = Boolean(getCookie('token') && user);

    if (!isLoggedIn) {
      setDispatchCheckout(true);
      dispatch(setLoginPopup(true));
      return;
    }

    goToCheckout();
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  useEffect(() => {
    if (
      !isLoginPopupOpen &&
      cartData?.selectedTickets &&
      cartData?.selectedDate &&
      cartData?.selectedTime &&
      dispatchCheckout &&
      user
    ) {
      setDispatchCheckout(false);
      goToCheckout();
    }
  }, [isLoginPopupOpen, user, dispatchCheckout, cartData]);

  return {
    loading,
    tickets,
    handleTicket,
    handleAddToCart,
  };
};

export default useTickets;
